var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{staticClass:"mr-1",attrs:{"variant":"white","size":"sm"},on:{"click":function($event){return _vm.translate()}}},[_vm._v(" Auto-translate "+_vm._s(_vm.getLanguageName())+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }